import React, { memo } from "react";
import { FormattedMessage } from "@I18n/Components/FormattedMessage/FormattedMessage";
import { FileSignature } from "@UI/Components/Icons/FileSignature";
import { IExtendedMetric } from "@modules/ServiceProviders/types/serviceProvider.types";
import { MetricCard } from "../MetricCard";
import { MetricIconStatus } from "../MetricIconStatus";
import messages from "../messages";

interface ICharterCard {
  metric: IExtendedMetric | undefined;
  onClick?: () => void;
}

export const CharterCard = memo(({ metric, onClick }: ICharterCard) => {
  const reached =
    metric !== undefined &&
    metric.value !== null &&
    metric.threshold !== null &&
    Number(metric.value) >= Number(metric.threshold);

  return (
    <MetricCard
      title={<FormattedMessage {...messages.charterTitle} />}
      onClick={onClick}
      description={<FormattedMessage {...messages.charterDescription} />}
      state={reached ? "reached" : "not-reached"}
    >
      <MetricIconStatus
        icon={FileSignature}
        state={reached ? "success" : "default"}
        message={
          <FormattedMessage
            {...(reached
              ? messages.charterStatus
              : messages.charterStatusNotReached)}
          />
        }
      />
    </MetricCard>
  );
});

CharterCard.displayName = "CharterCard";
